export default __webpack_public_path__ + "static/media/goshen17.ed8669e2.jpg";